import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import {
  filterBuildingsInitAction,
  setSelectedBuildingAction,
  updateBuildingsFiltersAction,
} from '../../../actions/instances/buildings';
import mainSearchStyles from '../../../helpers/mainSearchStyles';
import './SearchBlock.scss';
import Api from '../../../services/Api';
import Icon from '../../atoms/Icon/Icon';

const loadFilters = async () => {
  const componentsResponse = await Api.get('/instances/building-components?per_page=500');
  const elementsResponse = await Api.get('/instances/building-elements?per_page=500');
  const typesResponse = await Api.get('types/building-types?per_page=500');
  return {
    components: componentsResponse.data.data,
    elements: elementsResponse.data.data,
    types: typesResponse.data.data,
  };
};

const SearchBlock = () => {
  const { countriesList } = useSelector(state => state.countries);
  const { dynastiesList } = useSelector(state => state.dynasties);
  const { tagsList } = useSelector(state => state.tags);
  const { mainFilters } = useSelector(state => state.buildings);
  const [elements, setElements] = useState([]);
  const [components, setComponents] = useState([]);
  const [types, setTypes] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    loadFilters().then((data) => {
      setElements(data.elements.map(element => ({
        label: `${element.name} [${element.code}]`,
        value: element.id,
        type: 'element',
      })));
      setComponents(data.components.map(component => ({
        label: `${component.name} [${component.code}]`,
        value: component.id,
        type: 'component',
      })));
      setTypes(data.types.map(type => ({
        label: `${type.name} [${type.code}]`,
        value: type.id,
        type: 'type',
      })));
    });
  }, []);
  const cities = countriesList.map(country => country.city).flat();
  const dropdownData = [
    {
      label: 'Building Type',
      options: types,
    },
    {
      label: 'Components',
      options: components,
    },
    {
      label: 'Elements',
      options: elements,
    },
    {
      label: 'Dynasty',
      options: dynastiesList.map(dynasty => ({
        label: `${dynasty.name} [${dynasty.code}]`,
        value: dynasty.id,
        type: 'dynasty',
      })),
    },
    {
      label: 'Region',
      options: cities.map(city => ({
        label: `${city.name} [${city.code}]`,
        value: city.id,
        type: 'city',
      })),
    },
    {
      label: 'Tags',
      options: tagsList.map(tag => ({
        label: tag.name,
        value: tag.id,
        type: 'tag',
      })),
    },
  ];
  return (
    <div className="search-area-wrapper">
      <div className="search-area container">
        <h3 className="search-header">Searching for something?</h3>
        <p className="search-tag-line">
          Try filtering buildings by these search parameters!
        </p>

        <div className="search-control">
          <div className="search-container">
            <Select
              options={dropdownData}
              className="search-term required"
              styles={mainSearchStyles}
              id="s"
              name="s"
              placeholder="Type your search terms here"
              isMulti
              value={mainFilters}
              onChange={(values) => {
                dispatch(updateBuildingsFiltersAction(values));
                dispatch(filterBuildingsInitAction());
              }}
            />
            <button
              type="button"
              className="add-button"
              onClick={() => {
                dispatch(setSelectedBuildingAction(undefined));
                history.push('buildings/create');
              }}
            >
              <Icon icon="plus" color="#000" />
            </button>
          </div>
          <div id="search-error-container" />
        </div>
      </div>
    </div>
  );
};

export default SearchBlock;
